import Vue from "vue";
import * as moment from "moment";
import { Component } from "vue-property-decorator";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ExerciceHistoryDto } from "../../dto/GenApi.iNotPaie.Dto/ExerciceHistoryDto";
import { ParametresInstance } from "../Controls/Parameters";
import { VariableHistoryDto } from "../../dto/GenApi.iNotPaie.Dto/VariableHistoryDto";


@Component({
    beforeRouteEnter(to, from, next) {
        next(v => {
            const vm = (v as HistoriqueVariables);
                vm.Init();
        });
    }
})
export default class HistoriqueVariables extends Vue {

    public dataReady = false;
    public listeExercices: ExerciceHistory[] = [];
    public exerciceSelectionne? : ExerciceHistory;
    public listeVariables: VariableHistoryDto[] = [];
    public curentOrderColumn = "EmployeeFullName";
    public orderingDesc = true;

    public Init(): void {
        if (ParametresInstance.societeCourante == undefined) {
            return;
        }

        if (this.listeExercices.length > 0) {
            return;
        }

        ServicesFactoryInstance.VariablesHistoryService.getExercices(data => {
            this.listeExercices.splice(0);
            if (data != undefined) {
                data.forEach(d => { this.listeExercices.push(new ExerciceHistory(d)) });
                this.exerciceSelectionne = this.listeExercices[0];
            }
            this.chargeListeVariables();
            this.dataReady = true;
        });
    }

    public orderBy(columnName: string): void {
        if (this.curentOrderColumn == columnName) {
            this.orderingDesc = !this.orderingDesc;
        } else {
            this.orderingDesc = true;
        }
        this.curentOrderColumn = columnName;
        this.doOrder();
    }

    public doOrder(): void {
        if (this.listeVariables != undefined) {
            this.listeVariables.sort(this.sortFunction);
        }
    }

    public sortFunction(a: any, b: any): number {
        if (a[this.curentOrderColumn] < b[this.curentOrderColumn]) {
            return (this.orderingDesc ? -1 : 1);
        }
        if (a[this.curentOrderColumn] > b[this.curentOrderColumn]) {
            return (this.orderingDesc ? 1 : -1);
        }

        return 0;
    }

    public getClassOfOrder(columnName: string, desc: boolean): string {
        if (columnName == this.curentOrderColumn && this.orderingDesc == desc) {
            return "active";
        }

        return "icons";
    }

    chargeListeVariables() {
        if (this.exerciceSelectionne == undefined)
            return;

        this.dataReady = false
        this.listeVariables.splice(0);
        ServicesFactoryInstance.VariablesHistoryService.GetVariablesHistory(this.exerciceSelectionne.Exercice.Year, this.exerciceSelectionne.Exercice.Month, data => {
            this.listeVariables = data;
            this.dataReady = true;

            this.$forceUpdate();
        });
    }

    public getMontantFormate(montant?: number) : string {
        if (montant == undefined)
            return "";

        //return montant.toFixed(2);

        return new Intl.NumberFormat('fr', {
            style: 'decimal',
            useGrouping: true,
            minimumFractionDigits: 2
        }).format(montant);

    }
}

export class ExerciceHistory {
    Exercice: ExerciceHistoryDto;
    Periode: Date;
    PeriodeFormatee: string;
    PeriodePourTri: number;

    constructor(exercice: ExerciceHistoryDto) {
        this.Exercice = exercice;
        this.Periode = new Date(this.Exercice.Year, this.Exercice.Month - 1, 1);
        this.PeriodeFormatee = this.getPeriode(this.Exercice.Year, this.Exercice.Month - 1);
        this.PeriodePourTri = moment.duration(moment.utc(this.Periode).diff(moment.utc(new Date()))).asSeconds();
    }
    getPeriode(annee: number, mois: number): string {
        let moisFormate: string = moment.utc().month(mois).format("MMMM")[0].toUpperCase() + moment.utc().month(mois).format("MMMM").slice(1);
        return moisFormate + " " + annee;
    }
}



// WEBPACK FOOTER //
// ./src/components/historiqueVariables/HistoriqueVariables.ts